<div class="fields-wrapper" [formGroup]="form">
  <mat-form-field class="app-date-time-date">
    <mat-label>Date</mat-label>
    <input matInput type="date" [required]="required" formControlName="date">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Heure</mat-label>
    <mat-select [required]="required" formControlName="hour">
      @for (hour of hours; track hour) {
        <mat-option [value]="hour">
          {{ hour }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Minute</mat-label>
    <mat-select [required]="required" formControlName="minute">
      @for (minute of minutes; track minute) {
        <mat-option [value]="minute">
          {{ minute }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
